import API from '../../services/api.svelte.js';
export function get(name, config = {}) {
    return API.get(`statistic/${name}`, config).catch(e=>{});
}

export function getPatchingRoadmap(config = {}) {
    return API.get("v2/patching-roadmap", config).catch(e=>{});
}

export function countAssetByKind(config = {}) {
    return API.get(`v2/asset/count_by_kind/`, config).catch(e=>[]);
}

export default {
    get,
    getPatchingRoadmap,
    countAssetByKind
}
